import { style } from 'typestyle'
export const mb12 = style({ marginBottom: '12px' })
